import { ValueFormatterParams, ValueGetterParams } from 'ag-grid-community'
import { isNil } from 'lodash-es'
import { DealDetail } from 'api'
import { DealsGridColumnId } from './DealsGridColumnNames'
import { Locale, Translation } from 'locale'

export function NAFormatter(columnId: DealsGridColumnId) {
  return (params: ValueFormatterParams) => {
    const initiatorColumnIdFilter: DealsGridColumnId[] = []
    const responderColumnIdFilter: DealsGridColumnId[] = [DealsGridColumnId.BUNDLE_NAME, DealsGridColumnId.DEAL_ORIGINATOR]

    if (!params.node || params.node.group) {
      return ''
    }

    if (params.data.ownOrder) {
      return initiatorColumnIdFilter.includes(columnId)
        ? Locale.translate(Translation.UC_NOT_APPLICABLE)
        : isNil(params.value)
        ? ''
        : params.value
    } else {
      return responderColumnIdFilter.includes(columnId)
        ? Locale.translate(Translation.UC_NOT_APPLICABLE)
        : isNil(params.value)
        ? ''
        : params.value
    }
  }
}

export function getTrader(
  orderFundTraderUsername: string | null,
  counterpartyTraderUsername: string | null,
  ownOrder: boolean,
  self: boolean
) {
  if (ownOrder) {
    return self ? orderFundTraderUsername : counterpartyTraderUsername
  } else {
    return self ? counterpartyTraderUsername : orderFundTraderUsername
  }
}

export function makeTraderGetter(self: boolean) {
  return function tradingEntityGetter(params: ValueGetterParams) {
    if (!params.node || params.node.group) {
      return ''
    } else {
      const { data }: { data: DealDetail } = params.node
      return getTrader(data.deal.traderUserId, data.deal.counterpartyTraderId, data.ownOrder, self)
    }
  }
}
